import { useReducer } from "react";
import { RequestState } from "../../../constants/request-state";
import { transactionNotesService } from "../../../services/transaction-notes.service";
import { notesRequestActions, NotesRequestReducer } from "../state/notes-request-state";

export function useTransactionNoteReplyDelete() {
    const [requestState, dispatch] = useReducer(NotesRequestReducer, {})

    const replyDeleteCallback = async (replyId: number) => {
        dispatch(notesRequestActions.stateChanged(replyId, RequestState.request));
        try {
            await transactionNotesService.deleteNoteReply(replyId);
        dispatch(notesRequestActions.stateChanged(replyId, RequestState.success));
            return true;
        } catch (e) {
        dispatch(notesRequestActions.stateChanged(replyId, RequestState.failure));
            return false;
        }
    }

    return { requestState, replyDeleteCallback };
}